import { registerDependency, FAKE, REAL } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export const SPEED_ORDER_ADD_TO_BASKET_API = Symbol('SPEED_ORDER_ADD_TO_BASKET_API')

export interface AddToBasketResponse {
  result: boolean
  message?: string
  error?: string
  product?: number
}

export class SpeedOrderAddToBasketRequest {
  constructor(
    private readonly addToBasketUrl: string,
    private readonly products: Array<[number, number | string]>
  ) {}

  get url(): string {
    return this.addToBasketUrl
  }

  get items(): Array<[number, number | string]> {
    return this.products
  }
}

export interface SpeedOrderAddToBasketAPI {
  addToBasket(request: SpeedOrderAddToBasketRequest): Promise<AddToBasketResponse>
}

@registerDependency(REAL, SPEED_ORDER_ADD_TO_BASKET_API)
export class SpeedOrderAddToBasketService implements SpeedOrderAddToBasketAPI {
  async addToBasket(request: SpeedOrderAddToBasketRequest): Promise<AddToBasketResponse> {
    try {
      const formData = new FormData()
      formData.set('items', JSON.stringify(request.items))

      const response = await fetch(request.url, {
        method: 'POST',
        body: formData
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      
      return data as AddToBasketResponse
    } catch (error) {
      return {
        result: false,
        error: error instanceof Error ? error.message : 'Unknown error occurred'
      }
    }
  }
}

@registerDependency(FAKE, SPEED_ORDER_ADD_TO_BASKET_API)
export class FakeSpeedOrderAddToBasketService implements SpeedOrderAddToBasketAPI {
  requests: SpeedOrderAddToBasketRequest[] = []
  response: AddToBasketResponse = { result: true, message: 'Products successfully added to basket' }
  throws: Error | null = null

  async addToBasket(request: SpeedOrderAddToBasketRequest): Promise<AddToBasketResponse> {
    this.requests.push(request)

    if (this.throws) {
      throw this.throws
    }

    return this.response
  }
}
